module.exports = __webpack_public_path__ + "fonts/baronsans-ultrathin-webfont.d1454775.woff2";